const uz = {
  category: [
    { _id: 1, name: "Bosh sahifa", slug: "" },
    { _id: 2, name: "Domen", slug: "domain" },
    { _id: 3, name: "Hosting", slug: "hosting" },
    { _id: 4, name: "Pochta", slug: "pochta" },
    { _id: 5, name: "Sayt", slug: "site" },
    { _id: 6, name: "Aloqa", slug: "aloqa" },
    { _id: 7, name: "Biz haqimizda", slug: "about" },
  ],
  sliderData: [
    {
      url: "./assets/carousel/hosting.png",
      title: "ISHONCHLI HOSTING XIZMATI",
      about:
        "-haftasiga 7 kun   24 soat uzluksiz -rezerevda saqlash -cheksiz internet trafik",

    },
    {
      url: "./assets/carousel/domain.png",
      title: "DOMENINGIZNI TEZ VA QULAY RO‘YXATDAN O‘TKAZING",
      about: "600 MB hosting+domen Marketing uchun yangi imkoniyat",
    },
    {
      url: "./assets/carousel/site.png",
      title: "SAYT YARATIB BERISH XIZMATI",
      about: "Istagingiz va didingizga mos keladigan saytga buyurtma bering",
    },
  ],
  headerCard: [
    {
      url: "./assets/headerCard/domain.png",
      title: "Domenni ro‘yxatdan o‘tkazish",
      info: "Milliy domen bilan biznesga ilk qadam ",
      slug: "domain",
    },
    {
      url: "./assets/headerCard/hosting.png",
      title: "Ishonchli hosting xizmati",
      info: "Ishlash uchun qulaylik haftasiga 7 kun 24 soat uzluksiz",
      slug: "hosting",
    },
    {
      url: "./assets/headerCard/site.png",
      title: "Websaytlar yaratib berish",
      info: "Istalgan murakkablikdagi saytlar biz uchun sifat birinchi o‘rinda",
      slug: "site",
    },
  ],
  domain: {
    title: "DOMENLARNI RO‘YXATGA OLISH",
    about:
      "Domen bo‘sh yoki bo‘sh emasligini tekshiring! So‘ng domenni ro‘yxatdan o‘tkazishga o‘ting.",
    aktive: "Domain band",
    noAktive: "Domain band emas",
    table: {
      title1: "Muddat",
      title2: "Ro‘yxatdan o‘tkazish",
      title3: "Muddatni uzaytirish",
      button: "Buyurtma berish",
    },
    information: {
      title1: "Kompyuterlashtirish markazi",
      about1:
        "davlat unitar korxonasi UZ domen nomlarini rasmiy ro’yxatga oluvchi (registrator) hisoblanadi",
      title2:
        "Internet tarmoqlar milliy segmenti domen nomlaridan foydalanish tartibi to'g'risida",
      about2: "nizomi muvofiqligida xizmat ko'rsatish amalga oshiriladi.",
    },
  },
  hosting: {
    title: "ISHONCHLI HOSTING XIZMATI",
    about:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected",
    card: {
      hajmi: "Hajmi",
      domain: "Domenlar",
      subdomain: "Supdomenlar",
      db: "DB Mysql",
      domainuz: "Domen.uz 1 yilga",
      pochta: "Pochta",
      trafik: "Trafik",
      backup: "Beckup olish",
      ftp: "FTP ulanish",
      dns: "DNS qo‘llash",
      access_log: "Access_log, error_log",
      total: "Umumiy to'lov:",
      button: "Buyurtma berish",
    },
    more: "Barcha ta’riflarni ko‘rish",
    less: "Ortga qaytarish",
    title2: "O‘zingizga qulay ta’rifni yarating",
  },
  site: {
    title: "SAYT YARATIB BERISH XIZMATI",
    about:
      "Hozirgi kunda mijozlarni saytdan foydalanishini osonlashtirish uchun sayt noyob va chiroyli dizaynga ega bo‘lishi hamda foydalanuvchiga qulay bo‘lishi juda muhim hisoblanmoqda",
    options: [
      "Turli xildagi saytlarni yaratib berish",
      "Saytingiz uchun maxsus dizayn",
      "Foydalanuvchilar uchun saytning qulay bo‘ishi",
      "Saytni planshet va mobil versiyalarini ishlab chiqish",
      "Saytingiz uchun domen va hosting xizmatlari",
    ],
    card: {
      title1: "Eski dizayndagi saytlarni yangilash",
      about1:
        "saytingizni zamonaviy dizayn hamda foydalanuvchiga qulay usulda yangilang",
      title2: "Yangi sayt yaratish",
      about2: "istagingiz va didingizga mos keladigan saytga buyurtma bering",
    },
    about2:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here",
    button: "SAYTGA BUYURTMA BERISH",
  },
  footer: {
    about:
      "Markaz viloyat hokimligida IT texnalogiyalarini rivojlantirish maqsadida 2008 yildan buyon faoliyat yuritib kelmoqda. Asosiy vazifalari davlat organlari, korxona va tashlikotlarda sohani rivojlantirish yangi bosqichlarga olib chiqish.",
    title1: "Manzil",
    map: "Farg‘ona shahar Alisher Navoi ko‘chasi 15-uy. Mo‘ljal: Aziya mehmonxonasi",
    contact1: "+99890 166 55 66",
    contact2: "+99890 166 55 66",
    title2: "Menyu",
    update: "Soʼngi martta saytdagi maʼlumotlar yangilangan kun: ",
    createdBy: "Sayt ishlab chiqildi:",
    logo: "./assets/logo/LogoWhiteText.png",
  },
};
const ru = {
  category: [
    { _id: 1, name: "Bosh sahifa ru", slug: "" },
    { _id: 2, name: "Domen", slug: "domain" },
    { _id: 3, name: "Hosting", slug: "hosting" },
    { _id: 4, name: "Pochta", slug: "pochta" },
    { _id: 5, name: "Sayt", slug: "site" },
    { _id: 6, name: "Aloqa", slug: "aloqa" },
    { _id: 7, name: "Biz haqimizda", slug: "about" },
  ],
  sliderData: [
    {
      url: "./assets/carousel/hosting.png",
      title: "ISHONCHLI HOSTING XIZMATI",
      about:
        "-haftasiga 7 kun   24 soat uzluksiz -rezerevda saqlash -cheksiz internet trafik",
    },
    {
      url: "./assets/carousel/domain.png",
      title: "DOMENINGIZNI TEZ VA QULAY RO‘YXATDAN O‘TKAZING",
      about: "600 MB hosting+domen Marketing uchun yangi imkoniyat",
    },
    {
      url: "./assets/carousel/site.png",
      title: "SAYT YARATIB BERISH XIZMATI",
      about: "Istagingiz va didingizga mos keladigan saytga buyurtma bering",
    },
  ],
  headerCard: [
    {
      url: "./assets/headerCard/domain.png",
      title: "Domenni ro‘yxatdan o‘tkazish",
      info: "Milliy domen bilan biznesga ilk qadam ",
      slug: "domain",
    },
    {
      url: "./assets/headerCard/hosting.png",
      title: "Ishonchli hosting xizmati",
      info: "Ishlash uchun qulaylik haftasiga 7 kun 24 soat uzluksiz",
      slug: "hosting",
    },
    {
      url: "./assets/headerCard/site.png",
      title: "Websaytlar yaratib berish",
      info: "Istalgan murakkablikdagi saytlar biz uchun sifat birinchi o‘rinda",
      slug: "site",
    },
  ],
  domain: {
    title: "DOMENLARNI RO‘YXATGA OLISH",
    about:
      "Domen bo‘sh yoki bo‘sh emasligini tekshiring! So‘ng domenni ro‘yxatdan o‘tkazishga o‘ting.",
    aktive: "Domain band",
    noAktive: "Domain band emas",
    table: {
      title1: "Muddat",
      title2: "Ro‘yxatdan o‘tkazish",
      title3: "Muddatni uzaytirish",
      button: "Buyurtma berish",
    },
    information: {
      title1: "Kompyuterlashtirish markazi",
      about1:
        "davlat unitar korxonasi UZ domen nomlarini rasmiy ro’yxatga oluvchi (registrator) hisoblanadi",
      title2:
        "Internet tarmoqlar milliy segmenti domen nomlaridan foydalanish tartibi to'g'risida",
      about2: "nizomi muvofiqligida xizmat ko'rsatish amalga oshiriladi.",
    },
  },
  hosting: {
    title: "ISHONCHLI HOSTING XIZMATI",
    about:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected",
    card: {
      hajmi: "Hajmi",
      domain: "Domenlar",
      subdomain: "Supdomenlar",
      db: "DB Mysql",
      domainuz: "Domen.uz 1 yilga",
      pochta: "Pochta",
      trafik: "Trafik",
      backup: "Beckup olish",
      ftp: "FTP ulanish",
      dns: "DNS qo‘llash",
      access_log: "Access_log, error_log",
      total: "Umumiy to'lov:",
      button: "Buyurtma berish",
    },
    more: "Barcha ta’riflarni ko‘rish",
    less: "Ortga qaytarish",
    title2: "O‘zingizga qulay ta’rifni yarating",
  },
  site: {
    title: "SAYT YARATIB BERISH XIZMATI",
    about:
      "Hozirgi kunda mijozlarni saytdan foydalanishini osonlashtirish uchun sayt noyob va chiroyli dizaynga ega bo‘lishi hamda foydalanuvchiga qulay bo‘lishi juda muhim hisoblanmoqda",
    options: [
      "Turli xildagi saytlarni yaratib berish",
      "Saytingiz uchun maxsus dizayn",
      "Foydalanuvchilar uchun saytning qulay bo‘ishi",
      "Saytni planshet va mobil versiyalarini ishlab chiqish",
      "Saytingiz uchun domen va hosting xizmatlari",
    ],
    card: {
      title1: "Eski dizayndagi saytlarni yangilash",
      about1:
        "saytingizni zamonaviy dizayn hamda foydalanuvchiga qulay usulda yangilang",
      title2: "Yangi sayt yaratish",
      about2: "istagingiz va didingizga mos keladigan saytga buyurtma bering",
    },
    about2:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here",
    button: "SAYTGA BUYURTMA BERISH",
  },
  footer: {
    about:
      "Markaz viloyat hokimligida IT texnalogiyalarini rivojlantirish maqsadida 2008 yildan buyon faoliyat yuritib kelmoqda. Asosiy vazifalari davlat organlari, korxona va tashlikotlarda sohani rivojlantirish yangi bosqichlarga olib chiqish.",
    title1: "Manzil",
    map: "Farg‘ona shahar Alisher Navoi ko‘chasi 15-uy. Mo‘ljal: Aziya mehmonxonasi",
    contact1: "+99890 166 55 66",
    contact2: "+99890 166 55 66",
    title2: "Menyu",
    update: "Soʼngi martta saytdagi maʼlumotlar yangilangan kun: ",
    createdBy: "Sayt ishlab chiqildi:",
    logo: "./assets/logo/LogoWhiteText.png",
  },
};
let language = localStorage.getItem("language");
window.addEventListener("language", () => {
  window.location.reload(false);
});
const Switcher = (lan) => {
  localStorage.setItem(
    "navbarCategories",
    JSON.stringify(lan.category.reverse())
  );
  return lan;
};
export default language === "uz"
  ? Switcher(uz)
  : language === "ru"
  ? Switcher(ru)
  : Switcher(uz);
